<template>
  <div class="big-box">
    <div class="container">
      <div class="pro-box" v-if="proInfo.id">
        <div class="homeNav">
          <span @click="$router.push('/home')">{{ $t("home") }} ></span>
          <span @click="$router.push('/product')">{{ $t("product") }} ></span>
          <span>{{ language =="ru" ? "تفاصيل المنتج":language =="zh" ? '产品详情':'Products Details' }}</span>
        </div>
        <!-- <div class="title">{{$t('DK.productDetails')}}</div> -->
        <div class="detail-box">
          <div class="img-info">
            <div class="goods-img">
              <pic-zoom
                :bigSrc="activeImg || proInfo.imgUrl"
                v-if="proInfo.imgUrl"
                :configs="{
                width: 592,
                height: 444,
                mW: 140,
                mH: 110,
                mBgc: 'rgba(0, 21, 41, 0.3)',
                mO: 0.6,
                scale: 3
              }"
              ></pic-zoom>
            </div>
          </div>
          <div class="pro-info">
            <div class="right-title">{{ $hs(proInfo.pr_Na,proInfo.pr_En_Na,proInfo.basicThreeLanguage) }}</div>
            <div class="label_No">
              <span>{{proInfo.co_Nu}}</span>
            </div>

            <div class="label_prc">
              <span>
                {{
                language === "en" ? 'Price': $t('language') === "الصينية" ? 'سعر المنتج':'产品价格'
                }}：
              </span>
              <span v-if="userInfo.status === 1" style="color: red;font-size: 18px;">
                <span>{{ userInfo.symbol }}{{Number(proInfo.price)}}</span>
              </span>
              <span v-else style="color: red;font-size: 16px;cursor: pointer;" @click="login">{{ $t("pleaseLogin") }}</span>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">{{$t('catgoriesList')}}：</span>
                <span class="label_content">{{ $hs(proInfo.cl_Na,proInfo.cl_Ne_Na,proInfo.cl_ThreeLanguage) }}</span>
              </div>
              <div class="label_items">
                <span class="label">{{$t('packing')}}：</span>
                <span class="label_content">{{ $hs(proInfo.ch_Pa,proInfo.en_Pa,proInfo.packThreeLanguage) }}</span>
              </div>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">{{$t('packingCapacity')}}：</span>
                <span class="label_content">{{ proInfo.in_Le || 0 }} x {{ proInfo.in_Wi || 0 }} x {{ proInfo.in_Hi || 0 }}CM</span>
              </div>
              <div class="label_items">
                <span class="label">{{$t("productSize")}}LWH(cm)：</span>
                <span class="label_content">{{ proInfo.ou_Lo || 0 }}PCS</span>
              </div>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">
                  {{
                  language === "en" ? 'Carton Size': $t('language') === "الصينية" ? 'مواصفات الصندوق الخارجي':'外箱规格'
                  }}(cm)：
                </span>
                <span class="label_content">{{ proInfo.ou_Le || 0 }} x {{ proInfo.ou_Wi || 0 }} x {{ proInfo.ou_Hi || 0 }}CM</span>
              </div>

              <div class="label_items">
                <span class="label">{{$t("GWAndNW")}}：</span>
                <span class="label_content">{{ proInfo.gr_We || 0 }} / {{ proInfo.ne_We || 0 }}KG</span>
              </div>
            </div>

            <div class="label_box">
              <div class="label_items">
                <span class="label">
                  {{
                  language === "en" ? 'CBM': $t('language') === "الصينية" ? 'حجم الصناديق الخارجية':'外箱体积'
                  }}
                  (M³)：
                </span>
                <span class="label_content">{{ proInfo.bulk_Stere || 0.00 }}(Cbm)</span>
              </div>

              <div class="label_items">
                <span class="label">
                  {{
                  language === "en" ? 'Packing Size': $t('language') === "الصينية" ? 'مواصفات التعبئة':'包装规格'
                  }}
                  LWH(cm)：
                </span>
                <span class="label_content">{{ proInfo.in_Le || 0 }} x {{ proInfo.in_Wi || 0 }} x {{ proInfo.in_Hi || 0 }}CM</span>
              </div>
            </div>
            <!-- <div>
              <span class="label">{{ $t('LLH.proClass') }}：</span>
              <span>{{ $hs(proInfo.cl_Na,proInfo.cl_Ne_Na,proInfo.cl_ThreeLanguage) }}</span>
            </div>
            <div>
              <span class="label">{{$hs('录入时间','Created Time')}}：</span>
              <span>{{ proInfo.createdTime }}</span>
            </div>
            <div>
              <span class="label">{{$hs('更新时间','Updated Time')}}：</span>
              <span>{{ proInfo.updatedTime }}</span>
            </div>-->
            <div class="cart-box">
              <el-button
                @click="click(proInfo,'')"
                type="primary"
                class="add-cart"
                icon="el-icon-shopping-cart-2"
              >{{ ifAdd(proInfo.co_Nu) ? $t('LLH.delCart') : $t('LLH.addCart') }}</el-button>
              <!-- <el-button @click="click(proInfo,'BuyNow')" type="primary" class="add-cart_now">{{$hs('立即购买','Buy Now','Comprar ahora')}}</el-button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="product-carousel" v-if="converList.length>0">
        <div class="like">{{ language === 'en' ? "You Might Like" : language === 'ru' ? ". أنت على حق" : "你可能会喜欢" }}</div>
        <div class="listItems">
          <div style="width: 50px;margin-left: 15px;" class="next">
            <i class="el-icon-arrow-left" v-if="converList.length>1" @click="$refs.listItemBox.prev()"></i>
          </div>
          <div class="pro-listitemsbox">
            <el-carousel
              :interval="5000"
              arrow="none"
              indicator-position="none"
              trigger="click"
              direction="horizontal"
              ref="listItemBox"
              :autoplay="false"
            >
              <el-carousel-item v-for="options in converList" :key="options">
                <div class="pro-listItemBox">
                  <div class="pro-item" v-for="(item,index) in options" :key="index" @click="gotolist">
                    <div class="pro-img">
                      <img :src="item.imgUrl" @click="getshow(item)" />
                    </div>
                    <div class="pro-info">
                      <p class="pr-no">{{ item.fa_No }}</p>
                      <p class="pr-na">{{ language === 'en' ? item.pr_En_Na : language === 'ru' ? item.basicThreeLanguage : item.pr_Na }}</p>
                    </div>
                    <div class="price-box">
                      <p class="price">
                        <span>{{ userInfo.symbol }}</span>
                        {{ userInfo.status === 1 ? Number(item.price) : $t('viewPrice')}}
                      </p>
                      <img
                        src="../../assets/tianshi/xuanzhong.jpg"
                        alt
                        style="margin-right: 10px;"
                        v-if="markCart(item.co_Nu)"
                        @click="handleToCart(item)"
                      />
                      <img src="../../assets/tianshi/weixuanzhong.jpg" alt style="margin-right: 10px;" v-else @click="handleToCart(item)" />
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div style="width: 50px;margin-right: 15px;text-align: right;" class="next">
            <i class="el-icon-arrow-right" v-if="converList.length>1" @click="$refs.listItemBox.next()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryPage, getDetail } from '@/api/product'
import { insertProductView, insertAddCart } from '@/api/statistics'
import { deletCartsApi, addCartsApi } from '@/api/cart'
import picZoom from '@/components/productBox/picZoom.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapActions, mapGetters, mapState } from 'vuex'
import transformMark from '@/utils/water'
export default {
  name: 'proDetail',
  components: {
    picZoom,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      productList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 20,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        ma_Nu: '',
        isAnd: false,
        conditionals: []
      },
      activeImg: '',
      activeIndex: 0,
      proInfo: {},
      converList:[],
      swiperOption: {
        slidesPerView: 4,
        initialSlide: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: false, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: false, // 修改swiper的父元素时，自动初始化swiper
        imgArr: [],
        preventLinksPropagation: false // 阻止点击事件冒泡
      },
      totalRows: 0,
      totalPage: 0
    }
  },
  computed: {
    markCart() {
      return coNu => {
        // 购物车列表为空，直接返回标记
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    },
    ...mapState("operate", ["language"]),
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),

    ifEnquiry() {
      return coNu => {
        let arr = this.getEnquiry[0].list || []
        return arr.findIndex(item => item.co_Nu === coNu) > -1
      }
    },

    // 已加购还是取消加购
    ifAdd() {
      return coNu => {
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    }
  },
  created() {
    this.initData()
    this.statisticsView()
  },
  mounted() {
    sessionStorage.setItem('detail', true)
  },

  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      setEnquiry: 'set_enquiry'
    }),
    onEnquiry(proInfo) {
      if (!(Object.keys(this.userInfo).length > 0)) {
        this.$refs.loginModal.open()
        return;
      }
      proInfo._num_ = !proInfo._num_
      this.setEnquiry(proInfo)
    },
    async initData() {
      await getDetail({ co_Nu: this.$route.query.coNu, client_Nu: this.userInfo.client_Nu || '' }).then(res => {
        if (res.success) {
          this.proInfo = res.data
          this.proInfo.imgList.forEach(item => {
            transformMark(item.filePath).then(
              result => {
                item.filePath = result
              }
            )
          })
          const ind = this.getEnquiry[0].list.findIndex(
            it => it.co_Nu === this.proInfo.co_Nu
          )
          if (ind > -1) {
            this.proInfo._num_ = true
          } else {
            this.proInfo._num_ = false
          }
          transformMark(res.data.imgUrl).then(
            result => {
              this.activeImg = result
            }
          )
        }
      })

      this.getSameProduct()
    },
    // 统计访问
    statisticsView() {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || '',
          pr_Na: this.proInfo.pr_Na || '',
          co_Nu: this.proInfo.co_Nu || '',
          fa_No: this.proInfo.fa_No || '',
          ma_Na: this.proInfo.ma_Na || '',
          ma_Nu: this.proInfo.ma_Nu || ''
        }
        insertProductView(obj).then(() => { })
      }
    },
    // 打开忘记密码
    forgetpassword() {
      this.$refs.resetPassModel.open()
    },
    // 统计加购
    statisticsAddCart(data) {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || '',
          pr_Na: data.pr_Na || '',
          co_Nu: data.co_Nu || '',
          fa_No: data.fa_No || '',
          ma_Na: data.ma_Na || '',
          ma_Nu: data.ma_Nu || ''
        }
        insertAddCart(obj).then(() => { })
      }
    },
    // 添加到购物车
    handleToCart(item) {
      // 必须登陆后才能添加购物车
      if (Object.keys(this.userInfo).length === 0) {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (this.markCart(item.co_Nu)) {
        deletCartsApi({
          userId: this.userInfo.id,
          coNus: [item.co_Nu]
        }).then(res => {
          if (res.success) {
            this.deleteCart(item.co_Nu)
          }
        })
      } else {
        addCartsApi({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: item.co_Nu,
          number: 1
        }).then(res => {
          if (res.success) {
            this.addCart({
              client_Nu: this.userInfo.client_Nu,
              userId: this.userInfo.id,
              co_Nu: item.co_Nu,
              fa_No: item.fa_No,
              imgUrl: item.imgUrl,
              in_En: item.in_En,
              number: 1,
              ou_Lo: item.ou_Lo,
              pr_En_Na: item.pr_En_Na,
              pr_Na: item.pr_Na,
              price: item.price
            })
          }
        })
      }
    },
    getScrollTop() {
      localStorage.setItem('scrollTop', JSON.stringify(0))
    },
    // 登录
    login() {
      if (Object.keys(this.userInfo).length === 0) {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
    },
    gotolist() {
      this.getScrollTop();
    },
    gotoDetail() {
      this.initData()
    },
    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    // 分页大小操作
    handleSizeChange(pageSize) {
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = pageSize
      this.getSameProduct()
    },
    // 分页翻页操作
    handleCurrentChange(pageNo) {
      this.queryParam.pageNo = pageNo
      this.getSameProduct()
    },
    handleMsg() {
      let content = this.$hs(
        '我们的工作人员会尽快联系您并为您开通账户高级权限。',
        'Our staff will contact you as soon as possible and open your account with advanced permissions',
        'Nuestro personal se pondrá en contacto con usted lo antes posible y abrirá permisos avanzados de cuenta para usted.'
      )
      this.$alert(content, this.$t('LLH.systemTip'), {
        confirmButtonText: this.$t('LLH.confirm'),
        callback: action => { }
      })
    },
    convertTo2DArray1(arr, chunkSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
      }
      return result;
    },
    getSameProduct() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('LLH.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.queryParam.cl_Nu = this.proInfo.cl_Nu
      this.queryParam.client_Nu = this.userInfo.client_Nu || ''
      queryPage(this.queryParam)
        .then(res => {
          if (res.success) {
            this.productList = res.data.rows || []
            this.queryParam.isAnd = false
            this.productList = this.productList.map(item => {
              const ind = this.getEnquiry[0].list.findIndex(
                it => it.co_Nu === item.co_Nu
              )
              if (ind > -1) {
                return { ...item, _num_: true }
              }
              return { ...item, _num_: false }
            })

            this.productList.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(
                result => {
                  item.imgUrl = result
                }
              )
            })
            this.converList = this.convertTo2DArray1(this.productList, 5)
            this.totalRows = res.data.totalRows
            this.totalPage = res.data.totalPage
          }
        })
        .finally(() => {
          loading.close()
        })
    },
    getshow(item) {
      this.$router.push({ path: '/proDetail', query: { coNu: item.co_Nu } })
      this.initData()
    },
    handleMsg() {
      let content = this.$hs(
        '我们的工作人员会尽快联系您并为您开通账户高级权限。',
        'Our staff will contact you as soon as possible and open your account with advanced permissions',
        'Nuestro personal se pondrá en contacto con usted lo antes posible y abrirá permisos avanzados de cuenta para usted.'
      )
      this.$alert(content, this.$t('LLH.systemTip'), {
        confirmButtonText: this.$t('LLH.confirm'),
        callback: action => { }
      })
    },
    click(proInfo, Buytype) {
      if (!this.userInfo.id) {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (!this.ifAdd(proInfo.co_Nu)) {
        // 添加商品
        if (this.userInfo) {
          addCartsApi({
            client_Nu: this.userInfo.client_Nu,
            userId: this.userInfo.id,
            co_Nu: proInfo.co_Nu,
            number: 1
          }).then(res => {
            if (res.success) {
              this.addCart({
                client_Nu: this.userInfo.client_Nu,
                userId: this.userInfo.id,
                co_Nu: proInfo.co_Nu,
                fa_No: proInfo.fa_No,
                imgUrl: proInfo.imgUrl,
                in_En: proInfo.in_En,
                number: 1,
                ou_Lo: proInfo.ou_Lo,
                pr_En_Na: proInfo.pr_En_Na,
                pr_Na: proInfo.pr_Na,
                price: proInfo.price,
                bulk_Stere: proInfo.bulk_Stere,
                bulk_Feet: proInfo.bulk_Feet,
                gr_We: proInfo.gr_We,
                ne_We: proInfo.ne_We,
                productRemark: proInfo.productRemark || ''
              });
              this.statisticsAddCart(proInfo)
            }
          })
        }
      } else {
        // 删除商品
        if (this.userInfo) {
          deletCartsApi({
            userId: this.userInfo.id,
            coNus: [proInfo.co_Nu]
          }).then(res => {
            if (res.success) {
              this.deleteCart(proInfo.co_Nu)
            }
          })
        }
      }
      if (Buytype == 'BuyNow') {
        this.$router.push({ path: '/cart' })
      }
    },

    // 图片经过时，设置大图
    hoverImg(data) {
      this.activeImg = data.filePath
    },
    // 图片点击时，设置大图
    setImg(data) {
      this.activeImg = data.filePath
    }
  }
}
</script>
<style lang="scss" scoped>
.el-carousel__item:nth-child(2n) {
  background-color: #fff;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff;
}
/* 方法1：使用深度选择器 */
:deep(.el-carousel__arrow) {
  display: none !important;
}

/* 方法2：更具体的选择器 */
:deep(.el-carousel__arrow--left),
:deep(.el-carousel__arrow--right) {
  display: none !important;
}
.big-box {
  padding: 10px 0;
  background-color: #f5f5f5;
  background: linear-gradient(135deg, #aee7fb, #fadbea 51%, #f9e1cf);
  .pro-box {
    padding: 20px;
    border-radius: 2px;
    min-height: 480px;
    background-color: #fff;
    border-radius: 12px;
    margin-top: 30px;
    .title {
      font-size: 24px;
      font-weight: 700;
      color: #143e52;
      margin: 0 0 20px 0;
    }
    .detail-box {
      display: flex;
    }
    & .img-info {
      & .goods-img {
        width: 592px;
        height: 444px;
        border: 1px solid #f0f0fa;
        border-radius: 12px;
      }

      .swiper {
        position: relative;
        box-sizing: border-box;
        margin-top: 10px;
        width: 100%;
        height: 65px;

        & .swiper-container {
          width: 86%;
          padding: 0 7%;
          height: 67px;
          position: relative;

          & .swiper-wrapper {
            height: 67px;
            display: flex;
            align-items: center;
          }

          & .swiper-slide {
            width: 20% !important;

            & .item-img {
              margin: 0 5px;
              height: 61px;
              border: solid 1px #f2f2f2;
              padding: 2px;
              display: flex;
              justify-content: center;

              & img {
                width: auto;
                max-width: 100%;
                max-height: 65px;
              }
            }
          }
        }
      }
    }

    & .pro-info {
      flex: 1;
      background-color: #fff;
      padding-left: 30px;
      color: #333;
      min-height: 480px;
      .right-title {
        margin-top: 10px;
        font-size: 20px;
        min-height: 26px;
        max-height: 100px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        color: #222222;
      }
      .label_box {
        display: flex;
        align-items: center;
        height: 50px;
        flex: 1;
        width: 90%;
        .label_items:nth-child(2n) {
          width: 50%;
        }
      }

      .cart-box {
        margin: 20px 0 0 0;
      }

      .label_items {
        display: flex;
        align-items: flex-start;
        width: 55%;
      }
      .label_items_right {
        display: flex;
        align-items: center;
      }
      .label_prc {
        margin: 20px 0 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
      .label_No {
        display: inline-block;
        color: #999999;
        margin-top: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 16px;
        height: 50px;
        background: #faf8f4;
        border-radius: 4px;
        width: 718px;
        line-height: 50px;
        padding-left: 15px;
        color: red;
        font-weight: 700;
      }
      .label {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #666666;
      }
      .label_content {
        width: 170px;
        flex: 1;
        height: 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 16px;
        font-weight: 500;
        text-align: left;
        color: #222222;
        line-height: 30px;
      }
    }
  }
}

.product-carousel {
  background: #ffffff;
  margin-top: 20px;
  margin-bottom: 40px;
  border-radius: 12px;
  overflow: hidden;
  .like {
    padding-top: 40px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    color: #222222;
  }
  .listItems {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0 0 0;
  }
  .next {
    i {
      font-size: 30px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.7);
      cursor: pointer;
    }
  }
  .pro-listItemBox {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .pro-listitemsbox {
    width: 100%;
    & .pro-item {
      position: relative;
      width: 248px;
      background-color: #fff;
      border-radius: 12px;
      margin-right: 20px;
      margin-bottom: 20px;
      &:nth-child(6n) {
        margin-right: 0;
      }

      & .ck-box {
        position: absolute;
        right: 5%;
        top: 1%;
      }

      & .pro-img {
        width: 245px;
        height: 186px;
        border: 1px solid #f0f0fa;
        border-radius: 12px;

        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        overflow: hidden;
        & img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 186px;
          transition-duration: 0.5s;
        }
      }

      & .pro-info {
        font-size: 14px;
        margin: 0 10px;
        & p {
          line-height: 30px;
          overflow: hidden;
          overflow: hidden;
          text-overflow: ellipsis;

          &.pr-no,
          &.pr-na {
            height: 30px;
          }
        }
      }

      & .price-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 10px;

        & .price {
          font-size: 14px;
          font-weight: bold;
          color: #ff0000;

          & span {
            font-size: 14px;
          }
        }

        img {
          cursor: pointer;
        }
      }
    }
  }
}

.add-cart {
  background-color: red;
  border-color: red;
  border-radius: 8px;
}
.add-cart_now {
  background-color: #fff;
  border-color: #e33c0b;
  border-radius: 21px;
  font-size: 16px;
  font-weight: 700;
  color: #e33c0b;
  margin-left: 20px;
}
:deep .el-pagination__total {
  margin: 0 20px;
}
.homeNav {
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  padding-top: 50px;
  margin-bottom: 20px;
  span:hover {
    color: #fadbea;
    cursor: pointer;
  }
}
</style>